<template>
  <div class="card w-100 h-100">
    <div class="card-header">
      Ընդհանուր նկարագիր
    </div>
    <div class="timeless-tender-card-body tender-card-body">
      <div class="row w-100 p-0 m-0">
        <div class="form-group col-md-6 tender-input-group tender-input-group-left">
          <float-label>
            <input
              v-model="tender.name"
              placeholder="Մրցույթի անվանում"
              type="text"
              name="name"
              class="tender-input pr-3"
            />
          </float-label>
        </div>
        <div class="form-group col-md-6 p-0 d-flex">
          <div class="form-group col-md-4 tender-input-group tender-input-group-center">
            <float-label>
              <input
                  v-model="tender.code"
                  placeholder="Մրցույթի ծածկագիր"
                  type="text"
                  name="name"
                  class="tender-input pr-3"
              />
            </float-label>
          </div>
          <div class="form-group col-md-8 p-0 d-flex">
            <div class="form-group col-md-6 tender-input-group tender-input-group-center">
              <float-label>
                <input
                    v-model="tender.unit"
                    placeholder="Չափման միավոր"
                    type="text"
                    name="unit"
                    class="tender-input pr-3"
                />
              </float-label>
            </div>
            <div class="form-group col-md-6 tender-input-group tender-input-group-right">
              <float-label>
                <input
                    v-model.number="tender.market_price"
                    v-positive-only.none-zero
                    placeholder="Շուկայական գին"
                    type="number"
                    class="tender-input"
                    id="procurement-name-ru"
                >
              </float-label>
            </div>
          </div>
        </div>
        <div class="form-group col-md-6 tender-input-group tender-input-group-left">
          <float-label >
            <textarea
                placeholder="Տեխնիկական բնութագիրը | Անհրաժեշտ է լրացնել հայերեն, սպառիչ, որպեսզի գնորդների և մասնակիցների համար լինի հասկանալի, առանց երկակի մեկնաբանությունների՝ հետագա խնդիրներից խուսափելու համար։ ՈՒՇԱԴՐՈՒԹՅՈՒՆ!!! Մրցակցություն ապահովելու նպատակով՝ արգելում է նշել մուտքագրվող ապրանքի ֆիրմային անվանումը, արտադրողը, մոդելը։"
                v-model="tender.specification"
                rows="4"
                id="other-requirements"
                class="tender-input h-100 py-2 br-8"
            ></textarea>
          </float-label>
        </div>
        <div class="form-group col-md-6 tender-input-group tender-input-group-right">
          <float-label >
            <textarea
                placeholder="Գնման պայմաններ | Օրինակ ՝ Գնորդից պատվերը ստանալուց հետո 2 աշխատանքային օրվա ընթացքում"
                v-model="tender.terms_of_purchase"
                rows="4"
                id="other-requirements"
                class="tender-input h-100 py-2 br-8"
            ></textarea>
          </float-label>
        </div>
        <div class="form-group col-md-6 tender-input-group tender-input-group-left">
          <float-label >
            <textarea
                placeholder="Վճարման պայմաններ | Օրինակ ՝ Ապրանքներն ընդունելուց հետո 2 աշխատանքային օրվա ընթացքում"
                v-model="tender.payment_terms"
                rows="4"
                id="other-requirements"
                class="tender-input h-100 py-2 br-8"
            ></textarea>
          </float-label>
        </div>
        <div class="form-group col-md-6 tender-input-group tender-input-group-right">
          <float-label >
            <textarea
                placeholder="Մատակարարման պայմաններ | Օրինակ՝ Մատակարարումն ու բեռնաթափումն իրականացվելու է մատակարարի կողմից՝ գնորդի կողից նախանշված հասցեով"
                v-model="tender.delivery_terms"
                rows="4"
                id="other-requirements"
                class="tender-input h-100 py-2 br-8"
            ></textarea>
          </float-label>
        </div>
        <div class="form-group col-md-6 tender-input-group tender-input-group-left margin-bottom-28">
          <label class="m-0 btn" :class="(picturesNames.length) ? 'btn-primary' : 'btn-light'">
            <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.231 13.0161V4.5H12.6733V13.0161L15.3656 10.3065L16.4233 11.371L12.9617 14.7581L11.904 15.8226L10.9425 14.7581L7.48096 11.371L8.53865 10.3065L11.231 13.0161ZM17.9615 17.9516V15.9193H19.5V17.758C19.5 18.7258 18.7308 19.5 17.7692 19.5H6.23077C5.26923 19.5 4.5 18.7258 4.5 17.758V15.9193H6.03846V17.9516H17.9615Z" fill="#006BE6"/>
            </svg>
            <span>Վերբեռնել Նկարներ</span> <input @change="previewImagesFile($event)" type="file" accept="image/*" multiple hidden>
          </label>
          <div v-if="picturesNames.length" class="helper-text">
            <span :key="index" v-for="(picture, index) in picturesNames">
              {{ picture }}
            </span>
            <i v-tooltip="'Ջնջել կցված նկարները'" @click.prevent.stop="deletePictures" class="ml-2 pointer text-danger remove far fa-trash-alt"></i>
          </div>
          <div v-else class="helper-text">Առավելագույնը 5 նկար (jpg,png,jpeg)</div>
          <div class="d-flex align-items-center justify-content-start ">
            <div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.1914 16.04H12.7268V11.0299H11.1914V16.04Z" fill="#006BE6"/>
                <path d="M12.8076 7.87891H11.1914V9.49507H12.8076V7.87891Z" fill="#006BE6"/>
                <path d="M12 4C7.55556 4 4 7.55556 4 12C4 16.4444 7.55556 20 12 20C16.4444 20 20 16.4444 20 12C20 7.55556 16.3636 4 12 4ZM12 18.303C8.44444 18.303 5.61616 15.4747 5.61616 12C5.61616 8.52525 8.44444 5.61616 12 5.61616C15.5556 5.61616 18.3838 8.44444 18.3838 12C18.3838 15.5556 15.4747 18.303 12 18.303Z" fill="#006BE6"/>
              </svg>
            </div>
            <div class="pl-2">
              <div class="helper-text">Արգելվում է կցել ապրանքի ֆիրմային անվանումը երևացող նկարներ։ <br/> Ֆիրմային անվանումները անհրաժեշտ է նշել առաջարկներ ներկայացնելիս։</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <confirm-modal confirmBtnText="Հաստատել" declineBtnText="Չեղարկել"/>

  </div>
</template>

<script>
  import 'vue-date-pick/dist/vueDatePick.css';
  import { required } from 'vuelidate/lib/validators';

  // Custom validator to check if the number of files is <= 5
  const maxImages = (value) => !value || value.length <= 5;

  // Custom validator to ensure that all files are images
  const isImageFile = (value) => {
    if (!value) return true; // Allow empty field if not required
    return Array.from(value).every(file => file.type.startsWith('image/'));
  };

  export default {
    name: 'CreateTenderForm',
    props: ['rows', 'tenderData', 'tenderCode', 'editView', 'category'],
    components: {
      ConfirmModal: () => import('@/components/helpers/ConfirmModal.vue'),
    },
    data() {
      return {
        isSaving: false,
        procedureTypes: [],
        regions: [],
        picturesNames: [],
        tender: {
          id: false,
          name: '',
          code: '',
          market_price: '',
          unit: '',
          specification: '',
          terms_of_purchase: '',
          payment_terms: '',
          delivery_terms: '',
          pictures: [],
        },
      }
    },
    computed: {
      currentOrganized() {
        return this.$store.getters['organize/currentOrganized']
      },
      organizedRows() {
        return this.$store.getters['organize/organizedRows']
      },
      me() {
        return this.$store.getters['user/me']
      },
    },
    watch: {
      tenderCode: {
        immediate: true,
        async handler(data) {
          console.log('tenderCode', data)
          if(data){
            this.tender.code = data
          }
          console.log('tender', this.tender)
        },
      },
    },
    mounted() {
      if(this.tenderData){
        this.tender.id = this.tenderData.id;
        this.tender.code = this.tenderData.code;
        this.tender.name = this.tenderData.name;
        this.tender.unit = this.tenderData.unit;
        this.tender.market_price = this.tenderData.market_price;
        this.tender.delivery_terms = this.tenderData.delivery_terms;
        this.tender.payment_terms = this.tenderData.payment_terms;
        this.tender.specification = this.tenderData.specification;
        this.tender.terms_of_purchase = this.tenderData.terms_of_purchase;
        this.tender.pictures = this.tenderData.pictures;
        this.picturesNames = this.tenderData.pictures;
      }
    },
    methods: {
      deletePictures() {
        this.picturesNames = [];
        this.tender.pictures = null;
      },
      previewImagesFile(event) {
        const files = event.target.files;
        this.tender.pictures = event.target.files;
        console.log()
        this.tender.pictures.forEach(picture => {
          this.picturesNames.push(picture.name);
        })

        if (files.length > 5) {
          alert('You can only upload a maximum of 5 images.');
          return;
        }

        // Loop through files and ensure they are images
        for (const file of files) {
          if (!file.type.startsWith('image/')) {
            alert('Only image files are allowed.');
            return;
          }
        }

        // Process the valid image files
        // For example, upload or preview them
        console.log('Selected files:', files);
      },
      previewInvitationFile(event) {
        const file = event.target.files[0]
        if (file.size < 100000000) {
          this.tender.invitation_file = file;
          this.invitation_file_name = file.name
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Ընտրված ֆայլի առավելագույն ծավալը պետք է լինի 10ՄԲ'
          })
        }
      },
      getSelectedMembers(members) {
        console.log('members', members)
        this.tender.members = JSON.stringify(members);
        console.log('this.tender', this.tender)
      },
      confirm() {
        if(!this.$v.tender.$invalid) {
          if(this.rows.length && this.category?.value){
            return new Promise((resolve, reject) => {
              this.isSaving = true;
              const formData = new FormData();

              Object.keys(this.tender).forEach((key) => {
                if (key !== 'pictures') {
                  formData.append(key, this.tender[key]);
                }
              });

              if (this.tender.pictures && this.tender.pictures.length > 0) {
                for (let i = 0; i < this.tender.pictures.length; i++) {
                  formData.append(`pictures[]`, this.tender.pictures[i]);
                }
              }

              formData.append('cpvs', this.rows[0].id);
              formData.append('category', this.category?.value);
              console.log(formData, 'formData');

              const endpoint = this.tenderData
                ? `timeless-tenders/update/${this.tenderData.id}`
                : 'timeless-tenders';
              const successMessage = this.tenderData
                ? 'Հաջողությամբ խմբագրված է'
                : 'Հաջողությամբ հաստատված է';

              // KEY FIX: ALWAYS use .catch() to handle errors
              this.$client.post(endpoint, formData)
                .then(({data}) => {
                  this.isSaving = false;
                  this.$notify({
                    group: 'foo',
                    type: 'success',
                    text: successMessage
                  });
                  this.$router.push('/timeless-tenders/buy/list');
                  resolve(data);  // ✅ RESOLVE on success
                })
                .catch((error) => {
                  this.isSaving = false;  // ✅ SET FALSE ON ERROR
                  this.$notify({
                    group: 'foo',
                    type: 'error',
                    text: 'Տեղի ունեցավ սխալ: Փորձեք կրկին'
                  });
                  console.error('Tender error:', error);
                  reject(error);  // ✅ REJECT so parent catch fires
                });
            });
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Ընտրեք գնման առարկա և կատեգորիա հաստատելու համար'
            });
            return Promise.reject(
              new Error('Ընտրեք գնման առարկա և կատեգորիա հաստատելու համար')
            );
          }
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
          });
          return Promise.reject(
            new Error('Լրացրեք բոլոր դաշտերը հաստատելու համար!')
          );
        }
      },
    },
    validations() {
      const rules = {
        tender: {
          name: { required },
          code: { required },
          market_price: { required },
          specification: { required },
          terms_of_purchase: { required },
          payment_terms: { required },
          delivery_terms: { required },
        },
      }
      if(this.tender.id === false){
        Object.assign(rules.tender, {
          pictures: { required, maxImages, isImageFile },
        })
      }
      return rules
    }
  }
</script>

<style scoped>
textarea.tender-input::-webkit-input-placeholder {
  font-size: 12px;
}
</style>
